"use strict";
var e, r;
function t() {
  return r || (r = 1, e = typeof Reflect < "u" && Reflect && Reflect.apply), e;
}
export {
  t as __require
};
//# sourceMappingURL=index.es467.js.map
